/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperUtil {
    private static configuracoes: { minimo_lucro_total_carta: number, quantidade_minima_novas_cartas_relacionadas: number } = { minimo_lucro_total_carta: 100000, quantidade_minima_novas_cartas_relacionadas: 1 };
    private static jogadoresFutbinOrg: IPlayerInfoFilterFutbinOrg[] = null;
    constructor() {

    }

    public static setConfiguracoes(configuracoes: any) {
      TopSniperUtil.configuracoes = configuracoes;
    }

    public static salvarFiltroPiloto(urlUpdateFiltro: string, dadosFiltro: any) {
      let ajax = new App.Ajax();
      ajax.postAcaoSemCabecalhoGlobal(urlUpdateFiltro, dadosFiltro);
    }

    public static getMenorPreco(inputString: string, precoMin: number = null) {
      // Passo 1: Dividir a string em uma matriz usando a vírgula como delimitador
      var stringArray = inputString.split(', ');

      // Passo 2: Converter cada string para um número
      var numericArray = stringArray.map(function (str) {
        return parseInt(str, 10);
      });

      // Passo 3: Ordenar o array numérico
      numericArray.sort(function (a, b) {
        return a - b;
      });

      try {
        return precoMin && numericArray[0] < precoMin ? precoMin : numericArray[0]
      } catch (error) {
        return numericArray[0]
      }
    }

    public static getVariacaoFiltroFernando(valor: any) {
      switch (true) {
        case valor <= 40000:
          return 12;
        case valor <= 80000:
          return 8;
        default:
          return 4;
      }
    }

    public static getIncrementoPrecoCompraFernando(valor: any) {
      switch (true) {
        case valor < 50000:
          return 12;
        case valor < 100000:
          return 6;
        default:
          return 2;
      }
    }

    public static filtrarCartarRelacionadasPorRaridade(assetIdCartaPrincipal: number, cartas: any[], raridadeId: any, valorLimiteCompra: number, lucroMinimoUnitarioCartasRelacionadas: number) {
      return cartas
        .filter(function (ele: ICartaTopSniper) {
          return ele.raridade.id == raridadeId && ele.asset_id != assetIdCartaPrincipal
            && ele.quantidade_mais >= TopSniperUtil.configuracoes.quantidade_minima_novas_cartas_relacionadas
            && ele.lucro >= TopSniperUtil.configuracoes.minimo_lucro_total_carta
            && ele.valor <= valorLimiteCompra
            && ele.preco > valorLimiteCompra
            && (Util.getLucroCarta(valorLimiteCompra, ele.preco) >= lucroMinimoUnitarioCartasRelacionadas);
        })
        .sort(function (a: ICartaTopSniper, b: ICartaTopSniper) {
          return b.lucro_unitario - a.lucro_unitario; // Ordena em ordem decrescente de lucro
        });
    }

    public static async filtrarPlayerInfoOrg(nome: string, resourceId: any): Promise<IPlayerInfoFilterFutbinOrg> {
      try {
        this.jogadoresFutbinOrg = await this.getAllPlayersFutbinOrg(nome)
        let playersInfo = await this.jogadoresFutbinOrg.filter((jogadorInfo: IPlayerInfoFilterFutbinOrg) => jogadorInfo.resource_id.toString() == resourceId.toString())
        return playersInfo && playersInfo.length ? playersInfo[0] : null
      } catch (e) {
        return null;
      }
    }

    public static async getAllPlayersFutbinOrg(name: string): Promise<IPlayerInfoFilterFutbinOrg[]> {
      var response = await fetch(`${Util.URL_FUTBIN_ORG_API}searchPlayersByName?playername=${name}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36'
        }
      });

      let objJogador: any = await response.json();
      let todosJogadoresFutbinOrg: IPlayerInfoFilterFutbinOrg[] = objJogador['data'] && objJogador['data'].length ? objJogador['data'] : null

      return todosJogadoresFutbinOrg
    }

    public static async filtrarCartasQualidadeEspecialCompativelFiltro(topCartasMomento: ICartaTopSniper[], variacaoAtual: number = null): Promise<ICartaTopSniper[]> {
      const filteredCartas = await Promise.all(
        topCartasMomento.map(async (cartaTopSniper: ICartaTopSniper) => {
          let valorMaxCompraCartaConsiderandoVariacao = Util.getPrecoVariacaoMax(TopSniperUtil.getMenorPreco(cartaTopSniper.valor_all, cartaTopSniper.valor), variacaoAtual ? variacaoAtual : TopSniperUtil.getIncrementoPrecoCompraFernando(cartaTopSniper.valor));
          const entraNoFiltro = await this.jogadorEntraNoFiltroQualidadeEspecial(
            valorMaxCompraCartaConsiderandoVariacao,
            cartaTopSniper,
            Util.getStringPlataformaByIdPlataforma(cartaTopSniper.id_plataforma)
          );
          return entraNoFiltro ? cartaTopSniper : null;
        })
      );

      return filteredCartas.filter((cartaTopSniper: ICartaTopSniper) => cartaTopSniper !== null) as ICartaTopSniper[];
    }

    private static async jogadorEntraNoFiltroQualidadeEspecial(valorMaxCompraCartaConsiderandoVariacao: number, cartaTopSniper: ICartaTopSniper, platform = "PS"): Promise<boolean> {
      let jogadoresFutbinOrg = await this.getInfoJogadorByIdFutbinOrg(cartaTopSniper.player_info.ID, platform)
      let jogadoresNaoValidosParaFiltro = jogadoresFutbinOrg.filter((jogadorInfo: IPlayerInfoFutbinOrg) => {
        return jogadorInfo.price_type == "market" && jogadorInfo.Rare_Type > 1 && this.seDaPrejuizoOuLucroBaixo(valorMaxCompraCartaConsiderandoVariacao, Util.getMelhorPrecoFutbinEncontrado(jogadorInfo), 5000)
      })

      console.log('!!!RESULTADO:::', " | PRECO MAX:", valorMaxCompraCartaConsiderandoVariacao, " | JOGADOR VALIDO::", jogadoresNaoValidosParaFiltro.length == 0, jogadoresNaoValidosParaFiltro.length ? " | NOME:: " + cartaTopSniper.nome : "");

      return jogadoresNaoValidosParaFiltro.length == 0
    }

    private static async getInfoJogadorByIdFutbinOrg(idJogadorFutbin: string | number, platform = "PS"): Promise<IPlayerInfoFutbinOrg[]> {
      var response = await fetch(`${Util.URL_FUTBIN_ORG_API}fetchPlayerInformation?id=${idJogadorFutbin}&platform=${platform}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36'
        }
      });

      let objJogador: IDataPlayerInfoFutbinOrg = await response.json();
      let jogadoresFutbinOrg: IPlayerInfoFutbinOrg[] = objJogador['errorcode'] == "200" && objJogador['data'] && objJogador['data'].length ? objJogador['data'] : null

      return jogadoresFutbinOrg
    }

    private static seDaPrejuizoOuLucroBaixo(valorMaxCompraCartaConsiderandoVariacao: number, valorVenda: number, lucroMinimo: number = 1000) {
      var imposto = valorVenda * 0.05;
      var lucro = (valorVenda - imposto) - valorMaxCompraCartaConsiderandoVariacao;
      return lucro < lucroMinimo;
    }
  }
}
